import { FourOhOne } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

function UnAuthorized() {
    const { t } = useTranslation();
    const history = useHistory();

    return <FourOhOne tFunc={t} onLinkClick={() => history.push('/')} />;
}

export default UnAuthorized;
